import React from 'react';
import * as S from './fare-block.styles';
import ArrowLeftIcon from '../../../../../icons/ArrowLeft';
import ArrowRightIcon from '../../../../../icons/ArrowRight';

const FareDay = ({ fareData }) => {
  return (
    <S.CarouselItemWrap>
      <S.CarouselItem className="flexCol">
        <a className="flexCol alignItemsCenter" href={fareData.url}>
          <S.DateInfo>{fareData.date}</S.DateInfo>
          <S.FlightPrice>₹{fareData.price}</S.FlightPrice>
        </a>
      </S.CarouselItem>
    </S.CarouselItemWrap>
  );
};

const FareBlock = ({ data, handlePrevClick, handleNextClick }) => {
  return (
    <S.CarouselOne className="dF">
      <S.CarouselContainer className="dF">
        {data && data.map((fareData, index) => <FareDay key={index} fareData={fareData} />)}
      </S.CarouselContainer>
      <S.PrevNxtWrap className="dF alignItemsCenter">
        <S.Prev>
          <ArrowLeftIcon onClick={handlePrevClick} />
        </S.Prev>
        <S.Nxt>
          <ArrowRightIcon onClick={handleNextClick} />
        </S.Nxt>
      </S.PrevNxtWrap>
    </S.CarouselOne>
  );
};

export default FareBlock;
